import React, { useRef } from 'react';
import './styles.css';
import { TGCInput, TGCButton } from 'UI/elements';
import logo from 'assets/full-logo.png';
import { Bounce, toast } from 'react-toastify';
import { ToastContainer } from 'react-toastify';
import { app } from 'application';

export function DeleteUserAccountPage(): React.ReactElement {
  const credentials = useRef({
    username: '',
    password: '',
  });

  const usernameRef = useRef<HTMLInputElement>(null);
  const passwordRef = useRef<HTMLInputElement>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!usernameRef.current?.value || !passwordRef.current?.value) {
      toast.error('Please fill in all fields');
      return;
    } else if (usernameRef.current?.value.length < 4) {
      toast.error('Invalid username!');
      return;
    } else if (passwordRef.current?.value.length < 8) {
      toast.error('Invalid password!');
      return;
    }

    try {
      await app().userStore.login(credentials.current.username, credentials.current.password);

      if (
        window.confirm(`Are you sure you want to delete your account?
       This action cannot be undone.`)
      ) {
        await app().userStore.deleteAccount();
      }

      usernameRef.current!.value = '';
      passwordRef.current!.value = '';
      toast.error('Your account has been deleted!');
    } catch (error) {
      toast.error('Authentication failed!');
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    credentials.current[e.target.name as keyof typeof credentials.current] = e.target.value;
  };

  return (
    <div className="main-page">
      <img draggable={false} src={logo} alt="logo" />
      <div className="main-page-form">
        <TGCInput
          placeholder="Enter your username"
          type="text"
          name="username"
          onChange={handleChange}
          ref={usernameRef}
        />
        <TGCInput
          placeholder="Enter your password"
          type="password"
          name="password"
          onChange={handleChange}
          ref={passwordRef}
        />
        <TGCButton title="Delete my account" onClick={handleSubmit} />
      </div>

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Bounce}
      />
    </div>
  );
}
